export function getCheckData(listdata : string) : string {
    let isMinus = false;
    if (listdata.startsWith("-")) {
        listdata = listdata.substring(1);
        isMinus = true;
    }

    let digit;
    let number = listdata.split(".")[0] || "";
    let n = listdata;
    let n2 = n.slice(Math.max(n.length - 2, 1));

    let l1 = number.length;

    if (l1 === 6) {
        let firstdigit = number.substring(0, 1);
        let lastdigit = number.substring(1, 3);
        digit = `${firstdigit}.${lastdigit} L`;
    } else if (l1 === 7) {
        let firstdigit = number.substring(0, 2);
        let lastdigit = number.substring(2, 4);
        digit = `${firstdigit}.${lastdigit} L`;
    } else if (l1 === 8) {
        let firstdigit = number.substring(0, 1);
        let lastdigit = number.substring(1, 3);
        digit = `${firstdigit}.${lastdigit} C`;
    } else if (l1 === 9) {
        let firstdigit = number.substring(0, 2);
        let lastdigit = number.substring(2, 4);
        digit = `${firstdigit}.${lastdigit} C`;
    } else if (l1 === 10) {
        let firstdigit = number.substring(0, 3);
        let lastdigit = number.substring(3, 5);
        digit = `${firstdigit}.${lastdigit} C`;
    } else if (l1 === 11) {
        let firstdigit = number.substring(0, 4);
        let lastdigit = number.substring(4, 6);
        digit = `${firstdigit}.${lastdigit} C`;
    } else if (l1 === 12 || n2 === "E7") {
        let formattedNumber = Number(n).toFixed(15);
        let decimalPointIndex = formattedNumber.indexOf(".");
        let firstdigit = formattedNumber.charAt(0);
        let seconddigit = formattedNumber.substring(decimalPointIndex + 1, decimalPointIndex + 3);
        digit = `${firstdigit}.${seconddigit}C`;
    } else if (l1 === 13 || n2 === "E8") {
        let firstdigit = number.charAt(0);
        let lastdigit = n.charAt(2);
        let formattedNumber = Number(n).toFixed(2);
        let decimalPointIndex = formattedNumber.indexOf(".");
        let secondDigit = formattedNumber.substring(decimalPointIndex + 1, decimalPointIndex + 3);
        digit = `${firstdigit}${lastdigit}.${secondDigit}C`;
    } else if (l1 === 14 || n2 === "E9") {
        let firstdigit = number.charAt(0);
        let seconddigit = n.charAt(2);
        let thirddigit = n.charAt(4);
        digit = `${firstdigit}${seconddigit}${thirddigit}C`;
    } else if (l1 === 15 || n2 === "E10") {
        let firstdigit = number.charAt(0);
        let seconddigit = n.charAt(2);
        let thirddigit = n.charAt(4);
        let forthdigit = n.charAt(6);
        digit = `${firstdigit}${seconddigit}${thirddigit}${forthdigit}C`;
    } else if (l1 === 16 || n2 === "E11") {
        let firstdigit = number.charAt(0);
        let seconddigit = n.charAt(2);
        let thirddigit = n.charAt(4);
        let forthdigit = n.charAt(6);
        let fifthdigit = n.charAt(8);
        digit = `${firstdigit}${seconddigit}${thirddigit}${forthdigit}${fifthdigit}C`;
    } else {
        digit = number;
    }

    if (isMinus) {
        digit = "-" + digit;
    }

    return digit;
}
